import styled from 'styled-components';

import { WIDTH_SIDE_BAR, HEIGHT_HEADER, BORDER_COLOR_LINE_VERTICAL } from '../../../globals';


export const StyledPageContainer = styled.div`
  .page-header {
    margin-top: ${HEIGHT_HEADER - 1}px;
    border: none;
  }

  .page-sidebar {
    margin-left: ${WIDTH_SIDE_BAR}px;
  }

  .page-col-left-border {
    border-left: 1px solid ${BORDER_COLOR_LINE_VERTICAL};
  }

  .page-row, .page-col {
    min-height: -webkit-calc(100vh - ${HEIGHT_HEADER}px);
    min-height: -moz-calc(100vh - ${HEIGHT_HEADER}px);
    min-height: calc(100vh - ${HEIGHT_HEADER}px);
  }

  .page-col-fixed {
    top: ${HEIGHT_HEADER}px;
    right: 0px;
    position: fixed;

    width: -webkit-calc((100% - ${WIDTH_SIDE_BAR}px) * 0.5);
    width: -moz-calc((100% - ${WIDTH_SIDE_BAR}px) * 0.5);
    width: calc((100% - ${WIDTH_SIDE_BAR}px) * 0.5);

    height: -webkit-calc(100% - ${HEIGHT_HEADER}px);
    height: -moz-calc(100% - ${HEIGHT_HEADER}px);
    height: calc(100% - ${HEIGHT_HEADER}px);
  }

  .row-equal {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:         flex;
    flex-wrap: wrap;
  }
  .row-equal > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }


  @media (max-width: 992px) {
    .page-col-fixed {
      display: none;
    }

    .row-equal > [class*='col-'] {
      display: block;
    }

    .row-equal > .page-col-hide-md {
      display: none;
    }
  }


  @media (max-width: 767px) {
    .page-header {
      margin-top: 0px;
    }
  
    .page-sidebar {
      margin-left: 0px;
    }

    .page-row, .page-col {
      min-height: 0;
      width: 100%;
    }

    .page-col-fixed {
      top: inherit;
      right: inherit;
      position: fixed;
      width: inherit;
      height: inherit;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/PageContainer/styles/StyledPageContainer.js